import Vue from 'vue'
import App from './App'
import router from './router'
import directive from './directive' //directive

// 引入样式
import './assets/css/reset.css' 
import './assets/css/variables.scss'

// http请求
import Axios from './service/Axios.js'
import local from './service/index.js'
// 字典标签组件
import DictTag from '@/components/DictTag'
// 字典数据组件
import DictData from '@/components/DictData'

// 引用elementUI
import ElementUI from 'element-ui';           
import './assets/css/element-variables.scss'

import { getDicts } from "@/api/system/dict/data";



// 将自动注册所有组件为全局组件
import dataV from '@jiaminghi/data-view'
Vue.use(dataV)
Vue.use(ElementUI)
Vue.use(directive)
Vue.component('DictTag', DictTag)
DictData.install()

// 全局方法挂载
Vue.prototype.getDicts = getDicts
Vue.prototype.$Axios = Axios
Vue.prototype.$local = local
Vue.config.productionTip = false
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  render: h => h(App)
})

// var _hmt = _hmt || [];
// (function() {
//   var hm = document.createElement("script");
//   hm.src = "https://hm.baidu.com/hm.js?46b8b6667765f130b83871c1934686bd";
//   var s = document.getElementsByTagName("script")[0]; 
//   s.parentNode.insertBefore(hm, s);
// })();


//  router.beforeEach((to, from, next) => {
//   if (_hmt) {
//    if (to.path) {
//     _hmt.push(['_trackPageview', '/#' + to.fullPath]);
//    }
//   }
//   next();
//  });


// WEBPACK FOOTER //
// ./src/main.js